import React from 'react';
import { Card } from '../ui/Card';
interface KPIStripProps {
  metrics: {
    totalLeads: number;
    totalConverted: number;
    totalFunded: number;
  } | null;
}
export function KPIStrip({
  metrics
}: KPIStripProps) {
  if (!metrics) return null;
  const conversionRate = metrics.totalLeads > 0 ? (metrics.totalConverted / metrics.totalLeads * 100).toFixed(1) : '0.0';
  const fundedRate = metrics.totalLeads > 0 ? (metrics.totalFunded / metrics.totalLeads * 100).toFixed(1) : '0.0';
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-31">
      <Card className="p-6" data-id="element-32">
        <div className="text-sm font-medium text-[#706E6B] mb-2" data-id="element-33">
          Leads Claimed
        </div>
        <div className="text-3xl font-semibold text-[#181818] mb-1" data-id="element-34">
          {metrics.totalLeads.toLocaleString()}
        </div>
        <div className="text-sm text-[#706E6B]" data-id="element-35">Total cohort volume</div>
      </Card>

      <Card className="p-6" data-id="element-36">
        <div className="text-sm font-medium text-[#706E6B] mb-2" data-id="element-37">
          Converted to Opp
        </div>
        <div className="text-3xl font-semibold text-[#181818] mb-1" data-id="element-38">
          {metrics.totalConverted.toLocaleString()}
        </div>
        <div className="text-sm text-[#706E6B]" data-id="element-39">
          {conversionRate}% of claimed
        </div>
      </Card>

      <Card className="p-6" data-id="element-40">
        <div className="text-sm font-medium text-[#706E6B] mb-2" data-id="element-41">
          Funded Loans
        </div>
        <div className="text-3xl font-semibold text-[#181818] mb-1" data-id="element-42">
          {metrics.totalFunded.toLocaleString()}
        </div>
        <div className="text-sm text-[#706E6B]" data-id="element-43">{fundedRate}% pull-through</div>
      </Card>

      <Card className="p-6" data-id="element-44">
        <div className="text-sm font-medium text-[#706E6B] mb-2" data-id="element-45">
          Avg. Cycle Time
        </div>
        <div className="text-3xl font-semibold text-[#181818] mb-1" data-id="element-46">
          24 <span className="text-lg font-normal text-[#706E6B]" data-id="element-47">days</span>
        </div>
        <div className="text-sm text-[#706E6B]" data-id="element-48">Claimed to Funded</div>
      </Card>
    </div>;
}